/**
 * Pill-shaped selectable tag, used for genre/vocal/style pickers.
 *
 * Styles transcribed verbatim from the prototype.
 */
import { c } from '../../styles/theme';

export interface ChipProps {
  label: string;
  active?: boolean;
  onClick?: () => void;
}

export default function Chip({ label, active, onClick }: ChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      // Communicates selection to assistive tech. The prototype conveyed it with
      // colour alone, which a screen reader could not report.
      aria-pressed={Boolean(active)}
      style={{
        fontSize: 12,
        padding: '5px 12px',
        borderRadius: 999,
        border: active ? `1px solid ${c.accentBorder}` : `1px solid ${c.border}`,
        background: active ? c.accentSoft : 'transparent',
        color: active ? c.accent : c.text2,
        cursor: 'pointer',
        fontFamily: 'Inter',
      }}
    >
      {label}
    </button>
  );
}
